document.addEventListener('DOMContentLoaded', function() {
  // === ADD_TO_WISHLIST / REMOVE_FROM_WISHLIST ===
  document.body.addEventListener('click', function(e) {
      const icon = e.target.closest('.zooomypwishmsg');
      if (!icon) return;

      // console.log('[GA4] Wishlist icon clicked via delegation:', icon);

      // Defer until DOM updates
      requestAnimationFrame(() => {
          const wrapper = document.getElementById('ZlistWishlist');
          if (!wrapper) return;

          const inputCheckbox = wrapper.querySelector('input[type="checkbox"]');
          const isNowChecked = inputCheckbox?.checked;
          const eventName = isNowChecked ? 'add_to_wishlist' : 'remove_from_wishlist';

          const sku = wrapper.dataset.sku;
          const name = wrapper.dataset.title;
          const price = parseFloat(wrapper.dataset.price);
          const brand = 'Agnona';
          const variant = wrapper.dataset.variantname;
          const currency = Shopify.currency?.active;

          const payload = {
              event: eventName,
              ecommerce: {
                  currency: currency,
                  value: price,
                  items: [{
                      item_id: sku,
                      item_name: name,
                      item_brand: brand,
                      item_variant: variant,
                      price: price,
                      quantity: 1,
                      affiliation: 'Agnona Store'
                  }]
              }
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              ecommerce: null
          });
          window.dataLayer.push(payload);

          // console.log(`[GA4] ${eventName} pushed:`, payload);
      });
  });

  //SELECT ITEM
  // === SELECT_ITEM ===
  document.querySelectorAll('.block-swatch').forEach((swatch, index) => {
      swatch.addEventListener('click', () => {
          // console.log('[GA4] select_item: swatch clicked, processing...');

          const inputId = swatch.getAttribute('for');
          // console.log('[GA4] select_item: inputId from swatch:', inputId);
          const input = document.getElementById(inputId);
          if (!input) return;

          // console.log('[GA4] select_item: input element:', input);

          const payload = {
              event: 'select_item',
              ecommerce: {
                  item_list_id: 'swatches_selector',
                  item_list_name: 'Product Variant Selector',
                  items: [{
                      item_id: input.dataset.sku,
                      item_name: input.dataset.name,
                      item_brand: input.dataset.brand,
                      item_category: input.dataset.category,
                      item_variant: input.dataset.variant,
                      price: parseFloat(input.dataset.price),
                      quantity: 1,
                      index: index,
                      affiliation: 'Agnona Store',
                      item_list_id: 'swatches_selector',
                      item_list_name: 'Product Variant Selector'
                  }]
              }
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              ecommerce: null
          }); // clear previous
          window.dataLayer.push(payload);

          // console.log('[GA4] select_item pushed:', JSON.stringify(payload, null, 2));
      });
  });



//   === BEGIN_CHECKOUT MESSO IN ADDITIONAL SCRIPTS ===
  fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
          const currency = cart.currency;
          const value = cart.total_price / 100;

          const items = cart.items.map((item, index) => ({
              item_id: item.sku,
              item_name: item.product_title,
              item_brand: item.vendor,
              item_category: item.product_type,
              item_variant: item.variant_title,
              price: item.price / 100,
              quantity: item.quantity,
              index: index,
              affiliation: 'Agnona Store',
              // GA4 Optional fields:
              item_list_id: 'cart_items',
              item_list_name: 'Cart Items',
              coupon: item.discount_allocations?.[0]?.discount_application?.title || undefined,
              discount: item.discount_allocations?.[0]?.amount ? parseFloat(item.discount_allocations[0].amount) / 100 : 0,
          }));

          const payload = {
              event: 'begin_checkout',
              ecommerce: {
                  currency: currency,
                  value: value,
                  coupon: cart.cart_level_discount_applications?.[0]?.title || undefined,
                  items
              }
          };

          const checkoutBtn = document.querySelector('button[name="checkout"]');
          if (checkoutBtn) {
              checkoutBtn.addEventListener('click', function() {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                      ecommerce: null
                  });
                  window.dataLayer.push(payload);

                //   console.log('[GA4] begin_checkout pushed:', JSON.stringify(payload, null, 2));
              });
          } else {
            //   console.warn('[GA4] Checkout button not found.');
          }
      })
      .catch(err => {
          console.error('[GA4] Error fetching cart:', err);
      });
});